import { DatapointsEntityType, DatapointIdStandardEnum } from "api/ux/src";
import { addCustomFieldsAsDatapoints, addCustomFieldsAsCols } from "components/modal/portfolio-creation-edit/helper";
import { filterTagLabels } from "components/tags/helpers";
import { CustomColumnType } from "components/widgets/grid/grid-column-types";
import { getMeasuresAndDimensionsWithCurrency } from "hooks/use-funds-page";
import { useGetCustomDatapointFields } from "hooks/widget-data/use-datapoints";
import { language } from "language/default";
const mLanguage = language.en.administration.dataAdministration.exportData.assets;
export const useMeasuresAndDimensions = (groups) => {
    const customFields = useGetCustomDatapointFields([DatapointsEntityType.Asset]);
    const datapoints = [
        { datapoint: { standard: DatapointIdStandardEnum.AssetAssetId }, name: "Id" },
        { datapoint: { standard: DatapointIdStandardEnum.AssetAssetName }, name: "Name" },
        { datapoint: { standard: DatapointIdStandardEnum.AssetAssetKind }, name: "AssetKind" },
        { datapoint: { standard: DatapointIdStandardEnum.AssetSector }, name: "Sector" },
        { datapoint: { standard: DatapointIdStandardEnum.AssetCountry }, name: "Country" },
        { datapoint: { standard: DatapointIdStandardEnum.AssetWebsite }, name: "Website" },
        { datapoint: { standard: DatapointIdStandardEnum.AssetAssetCurrency }, name: "Currency" }
    ];
    if (customFields) {
        addCustomFieldsAsDatapoints(customFields, datapoints);
    }
    const [assetIdDatapoint, ...mesureDatapoints] = datapoints;
    const { dimensions, measures } = getMeasuresAndDimensionsWithCurrency([...groups], mesureDatapoints);
    dimensions.push(assetIdDatapoint);
    return { dimensions, measures };
};
export const useCreateColAsset = () => {
    const customFields = useGetCustomDatapointFields([DatapointsEntityType.Asset]);
    const managerCols = [
        { field: "Id", hide: true, lockVisible: true },
        { checkboxSelection: true,
            field: "Name",
            headerCheckboxSelection: true,
            headerCheckboxSelectionFilteredOnly: true,
            headerName: mLanguage.name,
            sort: "asc",
            type: [CustomColumnType.InsLinkColumn] },
        { enableRowGroup: true, field: "Currency", headerName: mLanguage.currency, type: CustomColumnType.InsTextSetColumn },
        { enableRowGroup: true, field: "AssetType", headerName: mLanguage.assetType, type: CustomColumnType.InsTextSetColumn },
        { enableRowGroup: true, field: "Sector", headerName: mLanguage.sector, type: CustomColumnType.InsTextSetColumn },
        { enableRowGroup: true, field: "Country", headerName: mLanguage.country, type: CustomColumnType.InsTextSetColumn },
        {
            enableRowGroup: true,
            field: "tags",
            filter: "agSetColumnFilter",
            filterValueGetter: filterTagLabels,
            headerName: "Tags",
            type: [CustomColumnType.InsTagsColumn]
        }
    ];
    const cols = [...managerCols];
    addCustomFieldsAsCols(customFields, cols);
    return cols;
};
